import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import examActions from "../../Redux/exam/actions";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import authActions from "../../Redux/auth/actions";
import { InputTrimFunction } from "../../utils/validations";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import loginLogo from "../../assets/images/login_logo.png";
import PrimaryButton from "../../common/primaryButton";

export default function Index() {
  // State declaractions
  const [passState, setPassState] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { projectDetails, heartBeat } = useSelector(
    (state) => state.examReducer
  );

  console.log(projectDetails, "projectDetails");
  
  const { buttonLoader } = useSelector((state) => state.commonReducer);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  // Derieved variables
  const url = searchParams.get("apiUrl");
  const isVenue = sessionStorage.getItem("isVenue");

  const textStyle = {
    fontSize: "16px",
    color: "#000",
    fontWeight: "500",
    mb: 1,
  };

  // Side effects
  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: url ? "undefined" : `${Cookies.get("test_engine_project")}`,
        },
        navigate: navigate,
        url: url,
      },
    });
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Helper functins

  const handleLogin = async (data) => {
    const formData = {
      ...data,
      projectShortName: projectDetails?.projectShortName,
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: authActions.CANDIDATE_LOGIN,
      payload: {
        data: encodedData,
        navigate: navigate,
        setError: setError, 
        mockMode: projectDetails?.mockMode,
        url: url,
      },
    });
  };

  return (
    <>
      <Grid
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          p: 2,
        }}
      >
        <Box
          sx={{
            background: "#fff",
            height: "35px",
            width: isOnline ? "130px" : "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            filter: "drop-shadow(0 4px 4px rgba(0, 0, 0, 0.12))",
          }}
        >
          {" "}
          <Typography
            sx={{
              color: isVenue
                ? heartBeat?.code === "OK"
                  ? "rgba(84, 179, 55, 1)"
                  : "rgba(234, 104, 58, 1)"
                : isOnline
                ? "rgba(84, 179, 55, 1)"
                : "rgba(234, 104, 58, 1)",
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
            }}
          >
            <span style={{ fontSize: "50px", fontWeight: "bold" }}>•</span>
            &nbsp;{isOnline ? "Connected" : "Disconnected"}
          </Typography>
        </Box>
      </Grid>
      <Grid
        component={"form"}
        onSubmit={handleSubmit(handleLogin)}
        sx={{
          height: "88vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            height: "430px",
            width: "520px",
            background: "#fff",
            borderRadius: "28px",
            padding: "30px",
            display: "flex",
            justifyContent: "center",
            border: "1px solid #00000029",
            boxShadow: "rgba(0, 0, 0, 0.12)",
            margin: "10px",
          }}
        >
          <Box
            component={"img"}
            src={projectDetails?.logo || loginLogo}
            alt="logo"
            sx={{ height: "100px", width: "auto" }}
          />
          <Grid item md={12} xs={12}>
            <FormControl fullWidth>
              <Typography sx={textStyle}>User ID </Typography>
              <TextField
                size="small"
                fullWidth
                placeholder="Enter User ID"
                id="username"
                type="text"
                variant="outlined"
                error={!!errors.username}
                {...register("username", {
                  required: "User ID is required",
                })}
                helperText={errors.username?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12}>
            <FormControl fullWidth>
              <Typography sx={textStyle}>Password</Typography>
              <TextField
                size="small"
                fullWidth
                id="password"
                placeholder="Enter Password"
                type={passState ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setPassState(!passState)}
                        sx={{ paddingRight: "0" }}
                      >
                        {passState ? (
                          <FiEye size={18} />
                        ) : (
                          <FiEyeOff size={18} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={!!errors.password}
                {...register("password", {
                  required: "Password is required",
                })}
                onInput={InputTrimFunction}
                helperText={errors.password?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12}>
            <PrimaryButton
              width="100%"
              color="#000"
              borderRadius="138px"
              height="38px"
              type="submit"
            >
              {buttonLoader ? "Logging in" : "Login"}
            </PrimaryButton>
          </Grid>
        </Grid>
        {/* <Typography
          variant="caption"
          sx={{ color: "rgba(30, 30, 30, 0.4)", size: "8px", padding: "4px" }}
        >
          IP : 192.168.0.1&nbsp;&nbsp;&nbsp;Mac Address :
          1233.F442.3444.5564&nbsp;&nbsp;&nbsp;PC Name: My computer
        </Typography> */}
      </Grid>
    </>
  );
}
